<template>
    <div>
        <div class="enterpriseName">
            <p>河北速保全网络科技有限公司</p>
            <div class="certificationBox">
                <div class="certification">已认证</div>
                <p @click="goCentre">企业中心</p>
            </div>
            <div class="generalSituation">
                <p>使用概况</p>
                <div class="schedule">
                    <div class="remain">
                        <el-progress type="circle" :percentage="50" color="#2751c7" :stroke-width="10" />
                        <p>剩余合同数/套</p>
                    </div>
                    <div class="remain">
                        <el-progress type="circle" :percentage="25" color="#2751c7" :stroke-width="10"/>
                        <p>已用合同数/套</p>
                    </div>
                    <div class="remain">
                    <el-progress type="circle" :percentage="25" color="#2751c7" :stroke-width="10"/>
                    <p>已提交案件/笔</p>
                </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import contractNumber from "./contractNumber";

    export default {
        name: "enterprise",
        methods:{
            goCentre(){
                console.log("企业中心")
            }
        },
        components:{
            contractNumber
        }
    }
</script>

<style scoped>
    .enterpriseName{
        padding: 30px 10px;
    }
    .enterpriseName>P{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
        padding-bottom: 10px;
    }
    .certificationBox{
     display: flex;
     justify-content: center;
     align-items: center
    }
    /*认证*/
    .certification{
        width: 80px;
        text-align: center;
        color: #fff;
        background-color: #3b63f6;
        margin-right: 15px;
        border-radius: 5px;
        padding: 5px;
    }
    .certificationBox>p{
        cursor:pointer;
        color: #3b63f6;
        border-bottom: 1px solid #8990a8;
    }
    .generalSituation>P{
        padding: 30px 20px;
        font-weight: 600;
    }
    .demo-progress .el-progress--line {
        margin-bottom: 15px;
        width: 350px;
    }
    .demo-progress .el-progress--circle {
        margin-right: 15px;
    }
    .schedule{
        display: flex;
        justify-content: space-around;
    }
    .remain{
        text-align: center;
    }
</style>
